import { useEffect, useState } from 'react'
import { DocketRecordViewer } from '@/agent-v2/references/DocketRecordViewer'
import type { DocketRecord } from '@/agent-v2/references/docket-record'
import ContentViewerErrorState from '@/content-viewer/components/common/ContentViewerErrorState'
import ContentViewerLoadingSpinner from '@/content-viewer/components/common/ContentViewerLoadingStates'
import { getTableReference } from '../fetch/get-table-reference'

/** Table membership authorizes this snapshot even after its originating chat is deleted. */
export function TableDocketRecordViewer({ tableId, referenceId }: { tableId: string; referenceId: string }) {
  const [result, setResult] = useState<{ tableId: string; referenceId: string; record: DocketRecord | null } | null>(null)
  const [error, setError] = useState(false)
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    const controller = new AbortController()
    setResult(null)
    setError(false)
    getTableReference(tableId, referenceId, controller.signal)
      .then((reference) => {
        if (!controller.signal.aborted) setResult({ tableId, referenceId, record: reference.docket ?? null })
      })
      .catch(() => {
        if (!controller.signal.aborted) setError(true)
      })
    return () => controller.abort()
  }, [tableId, referenceId, attempt])

  if (error) return <ContentViewerErrorState message="Failed to load the docket record." onRetry={() => setAttempt((value) => value + 1)} />
  if (!result || result.tableId !== tableId || result.referenceId !== referenceId) return <ContentViewerLoadingSpinner size="small" />
  return <DocketRecordViewer record={result.record ?? undefined} />
}
